import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function OtherSportsNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Other Sports",
    links: [
      {href: "/other-sports", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

OtherSportsNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default OtherSportsNav



// WEBPACK FOOTER //
// ./modules/OtherSports/nav/OtherSportsNav.js